// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xrrW","rootNoMargin":"styles_rootNoMargin__2YtzH"};